import { apps } from "../index-client.mjs";
const thirdpartyTracking = apps.thirdpartyTracking;
const {
  /**
 *
 */
  trackAdjust
} = thirdpartyTracking;
export {
  thirdpartyTracking,
  trackAdjust
};
/*                                     */
